import type { IGetStockStatusesQuery, IProductStockStatus } from "@jti/magento";

export const getSiblingItemsStockStatus = (stockStatusesData: IGetStockStatusesQuery) => {
  const stockStatuses: Record<string, IProductStockStatus> = {};

  stockStatusesData.products.items.forEach((item) => {
    stockStatuses[item.sku] = item.stock_status;
  });

  return stockStatuses;
};
